import React, { Component } from 'react'
import { connect } from 'react-redux'
import { removeMemberFromProject, changeMemberRoleProject, changeMemberTagsInProject, addMemberToProject } from '../../../../store/actions/projectActions';
import { get } from 'lodash';
import Loader from 'react-loader-spinner';

class AddMemberModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            newAccessLevel: -1,
            newAccessTitle: "",
        }
    }

    /// README: CALLING CLOUD FUNCTION TO: 
    // PAPID 3: ADD A MEMBER FROM COMPANY TO PROJECT
    addMemberToProject = () => {
        const { changerEmployeeMapJson, toBeChangedEmployeeMapJson, snagDetail } = this.props;
        const { newAccessLevel } = this.state;
        if (toBeChangedEmployeeMapJson && changerEmployeeMapJson) {
            this.props.addMemberToProject(changerEmployeeMapJson, toBeChangedEmployeeMapJson, newAccessLevel, snagDetail);
        }
    }

    handleRoleSelect = (prole) => {
        this.setState({
            newAccessLevel: prole.access,
            newAccessTitle: prole.title,
        })
    }

    componentDidMount() {
        const { alu } = this.props;
        this.setState({
            newAccessLevel: 1,
            newAccessTitle: alu.textLC[1]
        })
    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle, alu,project } = this.props;
        const { papiMessage,showPapiLoader } = project;
        const { newAccessTitle } = this.state;
        const relevantProjectRoles = alu.projectRolesForInternals;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    {/* ROLE SELECT */}
                    <div>
                        <p style={modalTitleStyle}>Select member role:</p>
                        <p style={modalInfoTextStyle}>* By selecting member role, app will allow member to view only relevant pages within the project.</p>
                        <br />
                        <div className="form-group text-left">
                            <div className="d-flex justify-content-between">
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <div className="dropdown show">
                                            <span className="btn btn-flat btn-sm dropdown-toggle border-bottom" role="button" id="roleDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {newAccessTitle} level
                                            </span>
                                            <div className="dropdown-menu border" aria-labelledby="roleDropdownMenuLink">
                                                {relevantProjectRoles.map((prole, i) => {
                                                    return (
                                                        <span style={{ fontSize: "13px" }} onClick={() => { this.handleRoleSelect(prole) }} role="button" className="dropdown-item" key={i} data-toggle="tooltip" data-placement="top">
                                                            {prole.title}
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <div className="btn btn-dark btn-sm" style={{ borderRadius: '10px' }} onClick={() => this.addMemberToProject()}>Add this member</div>
                                    </div>
                                </div>
                            </div>
                            {/* <p style={{ color: "black", fontWeight: "bold", fontSize: "13px", marginTop: '5px', textAlign: 'center' }}>{showPapiLoader?papiMessage ?? "":<React.Fragment/>}</p> */}
                            {
                                showPapiLoader?
                                <Loader
                                type="TailSpin"
                                color={this.props.themeColors.themeColor}
                                height={20}
                                width={20}
                            />:<React.Fragment/>
                            }                    
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        companyData: state.firestore.data.Company,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addMemberToProject: (changerEmployeeMapJson, toBeGivenAccessEmployeeMapJson, selectedLevel, projectModelJson) => dispatch(addMemberToProject(changerEmployeeMapJson, toBeGivenAccessEmployeeMapJson, selectedLevel, projectModelJson)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMemberModal)
